const env = process.env.REACT_APP_ENV;

let FE_URL;
let BE_URL;

switch (env) {
  case 'prod':
    FE_URL = 'https://fe.insurancehive.com';
    BE_URL = 'https://prod-api.insurancehive.com/api/v1';
    break;
  case 'dev':
    FE_URL = 'https://dev-fe.insurancehive.com';
    BE_URL = 'https://api-be.insurancehive.com/api/v1';
    break;
  case 'local':
  default:
    FE_URL = 'http://localhost:3001';
    BE_URL = 'http://localhost:3000/api/v1';
    break;
}

export { FE_URL, BE_URL };

